import {Card, TextField} from "@nike/eds";
import {edsSpace16} from "@nike/eds/dist/tokens";
import { useEffect, useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { BondedReturnService } from "./BondedReturnService";
import BondedReturnTriggeredModal from "./BondedReturnTriggeredModal";

interface UploadState {
    message: string,
    status: string
}

const formGroupStyle = {
    marginBottom: edsSpace16
}

const bondedReturnService = new BondedReturnService();


const BondedReturn = () => {
    const [file, setFile] = useState<File>();
    const [uploadStatus, setUploadStatus] = useState<UploadState>({
        message: '',
        status: 'pending'
    });
    const [completedVisible, setCompletedVisible] = useState(false);

    const handleFileSelectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target?.files;
        setFile(files ? files[0] : undefined);
    }

    useEffect(() => {
        if (uploadStatus.status === "triggering") {
            console.log("Trigger upload for ", file);
            bondedReturnService.uploadFile(file!, 
                (message) => setUploadStatus({status: 'uploading', message: message}),
                () => {
                    setFile(undefined);
                    setUploadStatus({status: 'uploaded', message: ''});
                    setCompletedVisible(true);
                });
        }
    }, [file, uploadStatus, setUploadStatus, setFile, setCompletedVisible]);

    const submitBondedReturn = () => {
        console.log("Submit ", file);
        setUploadStatus({
            message: 'Triggering upload',
            status: 'triggering'
        });
    }
        
    const isUploading = uploadStatus.status === "uploading";
    return  <div className="eds-grid eds-elevation--4">
              <Card>
                <div className="form-group" style={formGroupStyle}>
                  <TextField id="upload-bonded-return"
                            label="Select bonded return file"
                            type="file"
                            accept=".csv"
                            required
                            onChange={handleFileSelectionChange}
                            disabled={isUploading}
                    />
                </div>
                <div className="form-group form-group-last-item" style={formGroupStyle}>
                    <ButtonGroup>
                        <Button variant="primary" type="submit" 
                            onClick={submitBondedReturn} disabled={!file || isUploading}>Trigger increment</Button>
                    </ButtonGroup>
                    <span>{uploadStatus.message}</span>
                </div>
              </Card>
              <BondedReturnTriggeredModal isOpen={completedVisible} setIsOpen={setCompletedVisible} />
            </div>  
}

export default BondedReturn;
